import ShareButton from './ShareButton.container'

export default ShareButton
